import { flattenSharedFooterDisclaimers } from '@utils/sanity';
import { ModularLandingPageQuery } from './queries/modular-landing-page';
import { SanityGraphQLResponse } from 'types/sanity';
import { SanityModularLandingPageData } from 'types/sanity/modular-landing-page';
import { useQuery } from 'villus';
import { villusClient } from '@utils/villus';

type SanityModularLandingPageResponse = SanityGraphQLResponse<SanityModularLandingPageData, 'allModularLandingPage'>;

export async function getModularLandingPage(slug: string): Promise<SanityModularLandingPageData | null> {
	const { data } = await useQuery<SanityModularLandingPageResponse>({
		client: villusClient,
		query: ModularLandingPageQuery,
		variables: { slug },
		tags: ['modular_landing_page']
	}).execute();

	const page = data?.allModularLandingPage?.[0];

	if (!page) return null;

	if (page.footerDisclaimers && page.footerDisclaimers.length > 0) {
		page.flatFooterDisclaimers = flattenSharedFooterDisclaimers(page.footerDisclaimers);
	}

	return page;
}
